import React from 'react'
import cx from 'classnames'

import styles from './TableHead.module.scss'

type TableHeadProps = {
  children?: React.ReactNode
  className?: string
}

export const TableHead = ({ children, className }: TableHeadProps) => (
  <thead className={cx(styles.head, { [className ?? '']: Boolean(className) })}>
    {children}
  </thead>
)
